<template>
    <div class="relation-recommend" v-if="content&&content.length">
        <div class="recommend-title">相关推荐</div>
        <div :class="this.$router.currentRoute.query.type === 'productManual'?'items':'items course'">
            <div class="recommend-item" v-for="item in content" @click="viewDetail(item)">
                <img :src="item.cover">
                <div class="name">{{item.title}}</div>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        name: "RelationRecommend",
        props: {content:Array,type:String},
        methods:{
            viewDetail(item){
                // 如果是课程这个地方关联的手册，反之亦然
                let origin= location.origin
                if(this.$router.currentRoute.query.type != 'productManual'){
                    const preRouterName = this.$router.currentRoute.name
                    window.open(`${origin}/#/service-center/detail?id=${item.id}&type=liveCourse&currentRoute=${preRouterName}`)
                }else{
                    const preRouterName = this.$router.currentRoute.name
                    window.open(`${origin}/#/service-center/detail?id=${item.id}&type=productManual&currentRoute=${preRouterName}`)
                }
            }
        },
        mounted() {}
    }
</script>

<style scoped lang="scss">
    .relation-recommend {
        float: right;
        font-size: 16px;
        color: #ED6C00;
        font-weight: 600;
        width: 190px;
        text-align: left;
        margin-top: 20px;
        .recommend-title{
            font-weight: 500;
            font-size: 14px;
            line-height: 20px;
            color: #444444;
            padding-bottom: 8px;
            border-bottom: 0.5px solid #C4C4C4
        }
        .items{
            text-align: center;
            margin-top: 20px;
            &.course{
                .recommend-item img{
                    width: 176px;
                    height: 98px;
                }
            }
            .recommend-item{
               margin-bottom: 45px;
                img{
                    width: 136px;
                    height: 192px;
                    display: inline-block;
                    margin: auto;
                    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.1)
                }
                .name{
                    margin-top: 14px;
                    font-weight: 500;
                    font-size: 14px;
                    color: #444444;
                    overflow: hidden;
                    text-overflow:ellipsis;
                    white-space: nowrap;
                    max-width: 190px;
                    text-align: center;
                }

            }
        }
    }

</style>